export class EventData {
    name: string;
    value: any;
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}

export class EventName {
    public static readonly DICTIONARY_REQUEST_COMPLETED = 'DictionaryRequestCompleted';
    public static readonly CMS_LOAD = 'cms-load';
    public static readonly CNG_LOAD = 'cng-load';
    public static readonly BREADCRUMBS_LOAD = 'breadcrumbs-load';
    public static readonly HEADER_ADD_TO_CART_INDICATION = 'headerAddToCartIndication';
    public static readonly DYNAMIC_FIELD_CHANGED = 'DynamicFieldChanged';
    public static readonly DYNAMIC_FIELD_CHANGED_ERRORS = 'DynamicFieldChangedErrors';
    public static readonly REFRESH_CNG_PERMISSIONS_FIELDS = 'RefreshCngPermissionsFields';
    public static readonly MENU_NAVIGATE = 'MenuNavigate';
    public static readonly UPDATE_COMPARE_PRODUCTS = 'UpdateCompareProducts';
    public static readonly ENTITY_PAGE_QUERY_PARAMS_CHANGE = 'EntityPageQueryParamsChange';
    public static readonly TAXONOMY_NODE_CLICK = 'TaxonomyNodeClick';
    public static readonly HIDDEN_FILED_LOADED = 'HiddenFieldLoaded';
    public static readonly ENTITY_PAGE_DESTROY = 'EntityPageDestroy';
    public static readonly SAVE_SIGNATURE = 'SaveSignature';
    public static readonly VALIDATE_CUSTOM_ELEMENT = 'ValidateCustomElement';
    public static readonly CHANGE_DYNAMIC_FIELD_MODE = 'changeDynamicFieldMode';
    public static readonly HIDE_CMP_DEPEND_EL = 'hideCmpDependEl';
    public static readonly ENTITY_GET_ITEMS_RESPONSE = 'EntityGetItemsResponse';
    public static readonly ENTITY_NEW_HTML_RENDERED = 'EntityNewHtmlRendered';
    public static readonly ENTITY_PAGE_LOADED = 'EntityPageLoaded';
    public static readonly REFRESH_ENTITY_PAGE = 'RefreshEntityPage';
    public static readonly SELECT_TRIGGER_OPENED_CHANGE = 'SelectTriggerOpenedChange';
    public static readonly ENTITY_ACCORDION_CHANGE = 'EntityAccordionChange';
    public static readonly NEWS_LETTER_UNSUBSCRIBE = 'NewsLetterUnsubscibe';
    public static readonly GRID_GADGET_FILTER_CHANGE = 'GridGadgetFilterChange';
    public static readonly ENTITY_SCREEN_LOADED = 'EntityScreenLoaded';
    public static readonly SCREEN_CNG_LIST_BASE_CHANGE = 'ScreenCngListBaseChange';
    public static readonly DATA_FOR_ANALYTICS_READY = 'DataForAnalyticsReady';
    public static readonly AFTER_CHECKOUT_SUCCESS = 'AfterCheckoutSuccess';
    public static readonly EVENTS_TO_COLLAPSED_TREE = 'Events_To_Collapsed_Tree';
    public static readonly OPEN_TREE_VIEW_NODE = 'Open_Tree_View_Node';
    public static readonly CLOSE_SCREEN_ACTION_DIALOG = 'CloseScreenActionDialog';
}
